import { defineMessages } from 'react-intl';

export const ScopeName = 'Pages.Cart';

const Scope = defineMessages({
  title: {
    id: `${ScopeName}.title`,
    defaultMessage: 'Página do carrinho',
  },
  msgErrorModule: {
    id: `${ScopeName}.msgErrorModule`,
    defaultMessage: 'Não foi possível carregar o módulo federado',
  },
});

export default Scope;
